import { sygnet } from "./sygnet";
import { logo, logoWhite } from "./logo";
import helpscout from "./helpscout.svg";

import {
  cilBook,
  cilHamburgerMenu,
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibIntercom,
  cibZapier,
  cibZendesk,
  cibHubspot,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cilCommentBubble,
  cilBolt,
  cilFilter,
  cilThumbDown,
  cilThumbUp,
  cilExternalLink,
  cilSearch,
} from "@coreui/icons";
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from "@coreui/icons";
import {
  cilX,
  cilAddressBook,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowTop,
  cilArrowLeft,
  cilArrowBottom,
  cilAsterisk,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCheckAlt,
  cilCloudDownload,
  cilChartPie,
  cilChartLine,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilCaretBottom,
  cilCaretTop,
  cilDelete,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilGroup,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInfo,
  cilInput,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLibrary,
  cilLibraryAdd,
  cilLibraryBuilding,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilNoteAdd,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilPlus,
  cilReload,
  cilSave,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSitemap,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilSync,
  cilTags,
  cilTask,
  cilTrash,
  cilVideo,
  cilUnderline,
  cilUser,
  cilUserPlus,
  cilUserFemale,
  cilUserFollow,
  cilFolderOpen,
  cilUserUnfollow,
  cilXCircle,
  cilWarning,
} from "@coreui/icons";

export { helpscout };
export const icons = Object.assign(
  {},
  {
    sygnet,
    logo,
    logoWhite,
    helpscout,
  },
  {
    cilHamburgerMenu,
    cilBolt,
    cilAlignCenter,
    cilAddressBook,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowLeft,
    cilArrowRight,
    cilArrowTop,
    cilArrowBottom,
    cilAsterisk,
    cilBan,
    cilBasket,
    cilBell,
    cilBold,
    cilBook,
    cilBookmark,
    cilCaretBottom,
    cilCaretTop,
    cilCalculator,
    cilCalendar,
    cilCheckAlt,
    cilCloudDownload,
    cilChartPie,
    cilChartLine,
    cilCheck,
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCircle,
    cilCheckCircle,
    cilCode,
    cilCommentSquare,
    cilCommentBubble,
    cilCreditCard,
    cilCursor,
    cilCursorMove,
    cilDelete,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeLetter,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilGroup,
    cilFile,
    cilFullscreen,
    cilFullscreenExit,
    cilGraph,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInfo,
    cilInput,
    cilInputPower,
    cilItalic,
    cilJustifyCenter,
    cilJustifyLeft,
    cilLaptop,
    cilLayers,
    cilLibrary,
    cilLibraryBuilding,
    cilLibraryAdd,
    cilLightbulb,
    cilList,
    cilListNumbered,
    cilListRich,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMoon,
    cilNotes,
    cilNoteAdd,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPencil,
    cilPeople,
    cilPhone,
    cilPrint,
    cilPlus,
    cilPuzzle,
    cilReload,
    cilSave,
    cilScrubber,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilShieldAlt,
    cilSitemap,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilSync,
    cilTags,
    cilTask,
    cilTrash,
    cilVideo,
    cilUnderline,
    cilUser,
    cilUserPlus,
    cilUserFemale,
    cilUserFollow,
    cilUserUnfollow,
    cilFolderOpen,
    cilX,
    cilXCircle,
    cilWarning,
    cilThumbUp,
    cilFilter,
    cilThumbDown,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibSkype,
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibZapier,
    cibFlickr,
    cibTumblr,
    cibIntercom,
    cibZendesk,
    cibHubspot,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
    cilSearch,
    cilExternalLink,
  }
);
